<template>
  <span class="app-mark" aria-hidden="true">
    <span></span>
    <span></span>
    <span></span>
  </span>
</template>
